import { ExportConfig } from './types'
import { useOnceOffTransactionExportBase } from './useOnceOffTransactionExportBase'

interface UseOnceOffCardTransactionsExportProps {
  handleClose: () => void
  cardId?: string
}

export const useOnceOffCardTransactionsExport = ({
  handleClose,
  cardId,
}: UseOnceOffCardTransactionsExportProps) => {
  const config: ExportConfig = {
    walletIdResolver: () => ({
      lsid: cardId,
    }),

    amplitudePropsExtras: () => ({
      page: 'cards',
    }),

    features: {
      allowBalanceReport: false,
    },

    errorContext: 'CardTransactionExport',
  }

  return useOnceOffTransactionExportBase(config, handleClose)
}
